import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Stack, Switch, Tooltip, Typography } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Trans } from "react-i18next";
import type { CreateContentRequest } from "../multiformat/store/types";

export const PhotoTypeSelect: FC = () => {
  const { control } = useFormContext<CreateContentRequest>();

  return (
    <Controller
      name="db"
      control={control}
      render={({ field }) => (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography color="text.primary">Curated stock photography</Typography>
          <Switch
            id="photo-type-switch"
            data-analytics-id="photo-type-switch"
            onChange={(_, checked) => field.onChange(checked ? "stock" : "")}
            checked={field.value === "stock"}
            sx={{
              "& .MuiSwitch-thumb": {
                backgroundColor: "#7582EB",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#7582EB",
                opacity: 0.5,
              },
            }}
          />
          <Typography color="text.primary">Public stock photography</Typography>
          <Tooltip
            arrow
            title={
              <Trans>
                Choose whether your assets will use photography from our hand-picked library, or
                public stock imagery. There are more photos available with public stock, but quality
                and appropriateness aren’t guaranteed. You can switch later using “Edit prompt.”
              </Trans>
            }
          >
            <InfoOutlined color="action" />
          </Tooltip>
        </Stack>
      )}
    />
  );
};
